import { render, staticRenderFns } from "./redential.vue?vue&type=template&id=d84e970c&scoped=true&"
import script from "./redential.vue?vue&type=script&lang=js&"
export * from "./redential.vue?vue&type=script&lang=js&"
import style0 from "./redential.vue?vue&type=style&index=0&id=d84e970c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84e970c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\linlin\\wxcode\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d84e970c')) {
      api.createRecord('d84e970c', component.options)
    } else {
      api.reload('d84e970c', component.options)
    }
    module.hot.accept("./redential.vue?vue&type=template&id=d84e970c&scoped=true&", function () {
      api.rerender('d84e970c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/redential.vue"
export default component.exports